export * from './IconInput';
export { default } from './IconInput';
